import { PrimaryButton } from "src/components/common/PrimaryButton"
import { ArrowRightIcon } from "src/components/icons"
import { A } from "src/components/unstyled/A"

export type FeedbackProps = {
  title: string
  description: string
  linkHref: string
  linkText: string
}

export function Feedback({ title, description, linkHref, linkText }: FeedbackProps) {
  return (
    <div className="mx-auto flex min-h-[50vh] max-w-lg flex-col items-center justify-center gap-2 px-4 text-center">
      <h1 className="text-h2-serif">{title}</h1>
      <p className="text-lg text-pretty">{description}</p>

      <A href={linkHref} className="group mt-6">
        <PrimaryButton color="tertiary" size="small" as="div">
          {linkText}
          <ArrowRightIcon size={16} className="-rotate-45 duration-150 ease-in-out group-hover:rotate-0" />
        </PrimaryButton>
      </A>
    </div>
  )
}
